export const SCHEMA_CMS_PROJECT_ID = 2;

export const YEAR_FIELD = 'Year';

export const EDUCATIONAL_EXCHANGE = 'Educational Exchange';

export const USA = 'usa';
export const ASIA = 'asia';
export const ASEAN = 'asean';
export const INDONESIA = 'indonesia';
export const MEKONG = 'mekong';
export const AUSTRALIA = 'australia';
export const CHINA = 'china';
export const INDIA = 'india';
export const JAPAN = 'japan';
export const KOREA = 'korea';
export const TAIWAN = 'taiwan';
export const PACIFIC = 'pacific';
export const REGIONAL_MAP = 'regional-map';
export const GLANCE_TABLE = 'glance-table';
export const TABLE = 'table';
export const LINE_CHART = 'line-chart';
export const TREEMAP = 'treemap';

export const DEFAULT_FONT_SIZE = 20;

export const LIGHT_PREFIX = 'light_';
export const DROPDOWN_PREFIX = 'dropdown_';

export const REGIONS = {
  ASIA,
  ASEAN,
  MEKONG,
  INDONESIA,
  AUSTRALIA,
  CHINA,
  INDIA,
  JAPAN,
  KOREA,
  PACIFIC,
  TAIWAN,
  USA,
};

export const CHARTS = {
  REGIONAL_MAP,
  GLANCE_TABLE,
  TABLE,
  LINE_CHART,
  TREEMAP,
};

export const FONTS = {
  KNOCKOUT_69_FONT: "'Knockout 69 A', 'Knockout 69 B', Arial, Helvetica, Geneva, sans-serif",
  KNOCKOUT_50_FONT: "'Knockout 50 A', 'Knockout 50 B', Arial, Helvetica, Geneva, sans-serif",
  KNOCKOUT_32_FONT: "'Knockout 32 A', 'Knockout 32 B', Arial, Helvetica, Geneva, sans-serif",
  STANLEY: "'Stanley', Arial, Helvetica, Geneva, sans-serif",
  ARIAL: 'Arial, Helvetica, Geneva, sans-serif',
};
